import jsPDF from "jspdf";

export const KW_EMAIL = "muslimkidsindonesia@gmail.com";
export const MON_FULL = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

// Native pixel positions on each background image (x, baseline y; check = box center)
export const KW_LAYOUT = {
  sdqu: {
    bg: "/kwitansi_sd.jpg", w: 1266, h: 564, fs: 16,
    no: [1060, 97], from: [262, 210], words: [266, 256], spp: [274, 291], sppText: [382, 296],
    other: [274, 330], otherText: [306, 326], dev: [658, 289], uniform: [658, 327], date: [922, 403], total: [198, 502],
  },
  tk: {
    bg: "/kwitansi_tk.jpg", w: 1280, h: 574, fs: 16,
    no: [1066, 102], from: [252, 225], words: [268, 262], spp: [276, 297], sppText: [386, 302],
    other: [276, 337], otherText: [306, 342], dev: [665, 295], uniform: [665, 335], date: [956, 418], total: [200, 510],
  },
};

export const STUDENT_GAP = 40;

const SATUAN = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];
const tb = (n) => {
  if (n < 12) return SATUAN[n];
  if (n < 20) return `${SATUAN[n - 10]} Belas`;
  if (n < 100) return `${SATUAN[Math.floor(n / 10)]} Puluh ${tb(n % 10)}`;
  if (n < 200) return `Seratus ${tb(n - 100)}`;
  if (n < 1000) return `${SATUAN[Math.floor(n / 100)]} Ratus ${tb(n % 100)}`;
  if (n < 2000) return `Seribu ${tb(n - 1000)}`;
  if (n < 1e6) return `${tb(Math.floor(n / 1000))} Ribu ${tb(n % 1000)}`;
  if (n < 1e9) return `${tb(Math.floor(n / 1e6))} Juta ${tb(n % 1e6)}`;
  if (n < 1e12) return `${tb(Math.floor(n / 1e9))} Miliar ${tb(n % 1e9)}`;
  return `${tb(Math.floor(n / 1e12))} Triliun ${tb(n % 1e12)}`;
};
export const terbilang = (n) => (n > 0 ? `${tb(Math.floor(n))} Rupiah`.replace(/\s+/g, " ").trim() : "");
export const fmtRp = (n) => (n > 0 ? `${Number(n).toLocaleString("id-ID")},-` : "");
export const fmtDate = (s) => {
  if (!s) return "";
  const [y, m, d] = s.split("-");
  return `${d} ${MON_FULL[Number(m) - 1]} ${y}`;
};

export const studentLine = (k) => {
  const n = (k.student_name || "").trim();
  const c = (k.student_class || "").trim();
  if (!n && !c) return "";
  return [n && `Ananda ${n}`, c && `Kelas ${c}`].filter(Boolean).join(" ");
};
export const payLabel = (k) => [
  k.pay_dev && "Pembangunan & Pengembangan Pendidikan",
  k.uniform && "Seragam",
  k.spp && `SPP${k.spp_month ? ` ${MON_FULL[k.spp_month - 1]} ${k.spp_year || ""}` : ""}`,
  k.other && (k.other_text || "Lainnya"),
].filter(Boolean).join(", ");

export const kwTexts = (k) => ({
  student: studentLine(k),
  no: k.number || "",
  from: k.received_from || "",
  words: terbilang(Number(k.amount) || 0),
  sppText: k.spp && k.spp_month ? `${MON_FULL[k.spp_month - 1]} ${k.spp_year || ""}` : "",
  otherText: k.other ? k.other_text || "" : "",
  date: fmtDate(k.date),
  total: fmtRp(Number(k.amount) || 0),
});

const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });

export async function exportKwitansiPdf(k, school) {
  const L = KW_LAYOUT[school === "sdqu" ? "sdqu" : "tk"];
  const t = kwTexts(k);
  const img = await loadImg(L.bg);
  const pdf = new jsPDF({ orientation: "l", unit: "pt", format: [L.w, L.h] });
  pdf.addImage(img, "JPEG", 0, 0, L.w, L.h);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(L.fs);
  pdf.setTextColor(20, 20, 20);
  ["no", "from", "words", "sppText", "otherText", "date", "total"].forEach((key) => {
    if (t[key]) pdf.text(t[key], L[key][0], L[key][1]);
  });
  if (t.student) {
    pdf.setFont("helvetica", "bold");
    pdf.text(t.student, L.from[0] + (t.from ? pdf.getTextWidth(t.from) + STUDENT_GAP : 0), L.from[1]);
    pdf.setFont("helvetica", "normal");
  }
  pdf.setLineWidth(2.2);
  pdf.setDrawColor(20, 20, 20);
  [["spp", k.spp], ["other", k.other], ["dev", k.pay_dev], ["uniform", k.uniform]].forEach(([key, on]) => {
    if (!on) return;
    const [cx, cy] = L[key];
    pdf.lines([[5, 6], [10, -14]], cx - 8, cy, [1, 1], "S");
  });
  pdf.save(`Kwitansi_${(k.number || "baru").replace(/\//g, "-")}.pdf`);
}
